// extracted by mini-css-extract-plugin
export var container = "_c2-0";
export var containerTopRight = "_c2-1";